import { useSearchParams } from "react-router-dom";
import BiVaultLogo from "../../components/layout/BiVaultLogo";
import { useGoogleLogin } from "./useGoogleLogin";
import { useLanguage } from "../../components/ui/LanguageProvider";

export default function LoginPage() {
  const { login, loading, error } = useGoogleLogin();
  const [searchParams] = useSearchParams();
  const { t, language } = useLanguage();
  // 초대 링크(/login?invite=토큰) — 검증 주체는 서버의 email allowlist라 배너 안내만 한다
  const isInvited = Boolean(searchParams.get("invite"));

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--bg)",
    }}>
      <div style={{
        width: 420,
        background: "var(--surface-2)",
        border: "1px solid var(--border)",
        borderRadius: 16,
        padding: "40px 36px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 32,
      }}>
        {/* 로고 */}
        <BiVaultLogo
          style={{ width: 200, height: "auto", color: "var(--text-primary)" }}
        />

        {/* 구분선 */}
        <div style={{
          width: "100%",
          height: 1,
          background: "var(--border)",
        }} />

        {/* Google 로그인 버튼 */}
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 12 }}>
          <button
            onClick={login}
            disabled={loading}
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              padding: "11px 16px",
              background: loading ? "#e8e8e8" : "#ffffff",
              border: "1px solid #dadce0",
              borderRadius: 8,
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: 15,
              fontWeight: 500,
              color: "#3c4043",
              transition: "background 0.15s",
            }}
            onMouseEnter={e => { if (!loading) (e.currentTarget as HTMLButtonElement).style.background = "#f8f8f8"; }}
            onMouseLeave={e => { if (!loading) (e.currentTarget as HTMLButtonElement).style.background = "#ffffff"; }}
          >
            {/* Google G 아이콘 */}
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z" fill="#4285F4"/>
              <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z" fill="#34A853"/>
              <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z" fill="#FBBC05"/>
              <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z" fill="#EA4335"/>
            </svg>
            {loading ? t("로그인 중...", "Signing in...") : t("Google로 계속하기", "Continue with Google")}
          </button>

          {error && (
            <p style={{
              margin: 0,
              fontSize: 13,
              color: "var(--danger)",
              textAlign: "center",
            }}>
              {error}
            </p>
          )}
        </div>

        {/* 안내 문구 — info 콜아웃으로 강조 (초대 링크로 진입 시 게스트 안내로 교체) */}
        <p style={{
          margin: 0,
          width: "100%",
          padding: "10px 14px",
          boxSizing: "border-box",
          fontSize: 13,
          color: "var(--info)",
          background: "var(--info-soft)",
          border: "1px solid var(--info-border)",
          borderRadius: 8,
          textAlign: "center",
          lineHeight: 1.6,
        }}>
          {isInvited ? (
            language === "en"
              ? <>You've been invited as a guest. Sign in with <strong>the Google account for the invited email</strong>.</>
              : <>게스트로 초대되었습니다. <strong>초대받은 이메일의 Google 계정</strong>으로 로그인하세요.</>
          ) : (
            language === "en"
              ? <>Only <strong>colosseum.kr</strong> accounts can sign in.</>
              : <><strong>colosseum.kr</strong> 계정으로만 로그인할 수 있습니다.</>
          )}
        </p>

        {/* 로그인 동의에 연동 권한이 함께 들어간다 — 구글 화면에서 놀라지 않게 미리 알린다 */}
        {!isInvited && (
          <p style={{
            margin: "-20px 0 0",
            width: "100%",
            fontSize: 12,
            color: "var(--text-secondary)",
            textAlign: "center",
            lineHeight: 1.6,
          }}>
            {t("처음 로그인할 때 캘린더, 드라이브, 메일 연동 권한을 함께 요청합니다.", "On first sign-in, we also request Calendar, Drive and Mail integration permissions.")}
            <br />
            {t("연동은 설정 > 앱 연동에서 언제든 해제할 수 있습니다.", "You can disconnect them anytime in Settings > App integrations.")}
          </p>
        )}
      </div>
    </div>
  );
}
